import "./bootstrap";
import "../css/clusters.css";
import "../css/app.css";

import "vue-toastification/dist/index.css";
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import Toast, { POSITION } from "vue-toastification";
import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist/vue.m";
import VueSidePanel from "vue3-side-panel";
import "vue3-side-panel/dist/vue3-side-panel.css";
import { vfmPlugin } from "vue-final-modal";
import { VueSignaturePad } from "vue-signature-pad";
import "vue3-dropdown-navbar/preflight.css";
import ErrorComponent from "@/Components/Errors/ErrorComponent.vue";
import HasRoleOrPermissions from "@/Components/Settings/Users/HasRoleOrPermissions.vue";
// import VueApexCharts from "vue3-apexcharts";
import BaseLayout from "@/Components/Partials/BaseLayout.vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { createPinia } from "pinia";
import NotificationsPrioritaryComponent from "@/Components/NotificationsPrioritaryList.vue";
// import VueBarcode from '@chenfengyuan/vue-barcode';
import * as Sentry from "@sentry/vue";
import { vFitText } from "./src/directives/v-fit-text";
import { Icon } from "@iconify/vue";

const pinia = createPinia()

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";

    const savedTheme = localStorage.getItem("theme") || "theme-light-blue";
    document.documentElement.className = savedTheme;

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, app, props, plugin }) {
        const mainApp = createApp({ render: () => h(app, props) })
            .component("VueSignaturePad", VueSignaturePad)
            .component("ErrorComponent", ErrorComponent)
            .component("HasRoleOrPermissions", HasRoleOrPermissions)
            .component("BaseLayout", BaseLayout)
            .component("Icon", Icon)
            // .component("VueBarcode", VueBarcode)
            .use(plugin)
            .use(Toast, {
                position: POSITION.TOP_RIGHT,
                transition: "Vue-Toastification__bounce",
                maxToasts: 20,
                newestOnTop: true,
                timeout: 3500,
            })
            .use(VueSidePanel)
            .use(
                vfmPlugin({
                    key: "$vfm",
                    componentName: "VueFinalModal",
                    dynamicContainerName: "ModalsContainer",
                })
            )
            .use(ZiggyVue, Ziggy)
            // .use(VueApexCharts)
            .use(ElementPlus)
            .use(VueSweetalert2)
            .use(pinia)

            Sentry.init({
                app: mainApp, // Initialise avec ton application Vue
                dsn: "https://e267b0cd957629bd657f8901f6811463@o4509093787533312.ingest.de.sentry.io/4509093862834256",
                integrations: [],
                // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
                tracePropagationTargets: [
                    // "localhost",
                    /^https:\/\/optiplan\.marbrerie-pythagore\.fr/,
                    // /^https:\/\/yourserver\.io\/api/,
                ],
            });

            mainApp.directive("fit-text", vFitText);

            mainApp.mount(el);

             const notificationEl = document.getElementById(
                 "global-notifications"
             );
             if (notificationEl) {
                 const notifApp = createApp(NotificationsPrioritaryComponent);

                 notifApp.use(pinia);
                 notifApp.mount(notificationEl);
             }

        return mainApp;
    },
});

InertiaProgress.init({});
